module.exports = __webpack_public_path__ + "static/media/CMA-CGM.ca377726.svg";